module.exports = __webpack_public_path__ + "img/collection-weddingRingsSecretHeart.d3353bf.webp";